import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const tasks = (state = initialState.tasks, action) => {
  switch (action.type) {
    case types.LOAD_TASK_SUCCESS:
      return action.tasks;

    case types.CREATE_TASK_SUCCESS:
      return [...state, { ...action.task }];

    case types.UPDATE_TASK_SUCCESS:
      return [
        ...state.filter((s) => s.id !== action.task.id),
        { ...action.task }
      ];

    default:
      return state;
  }
};

export const task = (state = initialState.task, action) => {
  switch (action.type) {
    case types.GET_TASK_SUCCESS:
      return action.task;

    default:
      return state;
  }
};

export const savingTask = (state = initialState.savingTask, action) => {
  switch (action.type) {
    case types.SAVING_TASK:
      return action.savingTask;

    default:
      return state;
  }
};
